(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["hero-video"] && !window.DesignMode) return;
  try {
    
  var videos = document.querySelectorAll(".video-wrap");
  videos.forEach(function (video) {
    var videoPoster = video.querySelector(".video-poster");
    var videoElement = video.querySelector(".video-source");
    var iframe = video.querySelector("iframe");
  
    videoPoster.addEventListener("click", function () {
    videoPoster.classList.add("video-poster-hide");
      if (iframe) {
        iframe.style.display = "block"; // Show the iframe
        var iframeSrc = iframe.getAttribute("src");
        iframe.setAttribute("src", iframeSrc + "?autoplay=1&mute=1"); 
      } else if (videoElement) {
        videoElement.play();
      }
    });
    if (videoElement) {
      videoElement.addEventListener("ended", function () {
        videoPoster.classList.remove("video-poster-hide"); 
      });
    }
  });

  } catch(e) { console.error(e); }
})();

})();
